import { Overview } from 'ui/illustrations';
import { EmptyStateSubtitle, EmptyStateTitle, MetricBreakdownCardEmptyState } from './Styled';

export const NoDataCard = ({ title, subtitle, Icon = Overview }) => (
  <MetricBreakdownCardEmptyState>
    <Icon />
    <EmptyStateTitle data-test={`empty-state-title`}>{title}</EmptyStateTitle>
    <EmptyStateSubtitle data-test={`empty-state-subtitle`}>{subtitle}</EmptyStateSubtitle>
  </MetricBreakdownCardEmptyState>
);
